import React, { useCallback, useState } from 'react';
import { IoAdd as Plus } from 'react-icons/io5';
import { useAdminVisitsTable } from '@/hooks/useAdminVisitsTable';
import { Button, Modal } from '@/components/basic';
import { PaginatedTable } from '@/components/basic/Table/PaginatedTable';
import { DeleteVisitModal } from '@/components/station/DeleteVisitModal';
import { InviteVisitorForm } from '@/components/station/InviteVisitorForm';
import { VisitsFilters } from '@/components/station/VisitsFilters';
import { AdminVisitorsIndexProps } from '../admin/visitors/AdminVisitorsIndex';

type Props = {
  type: 'invitations' | 'visits';
} & AdminVisitorsIndexProps;

export default function VisitorsTable({ type, isRedesign, officeId }: Props) {
  const {
    editVisit,
    setEditVisit,
    deleteVisit,
    setDeleteVisit,
    hasChangedFromDefaults,
    filter,
    updateFilter,
    resetFilters,
    data,
    visits,
    columns
  } = useAdminVisitsTable(type, officeId);

  const [openVisitorModal, setOpenVisitorModal] = useState(false);
  const closeModal = useCallback(() => setOpenVisitorModal(false), []);
  const openModal = useCallback(() => setOpenVisitorModal(true), []);

  return (
    <div>
      <Modal
        title="Invite a Visitor"
        opened={openVisitorModal}
        onClose={closeModal}
        size="max-w-[45rem]"
      >
        <InviteVisitorForm closeModal={closeModal} />
      </Modal>
      <div className="flex flex-wrap items-center justify-between">
        <VisitsFilters
          type={type}
          filter={filter}
          updateFilter={updateFilter}
          isRedesign={isRedesign}
        />
        <div>
          <Button
            variant="primary"
            layout="squared"
            className="ml-4 inline-flex"
            onClick={openModal}
            iconLeft={Plus}
          >
            Invite Visitor
          </Button>
        </div>
      </div>

      {editVisit ? (
        <Modal
          title="Invite a Visitor"
          opened={!!editVisit}
          onClose={() => setEditVisit(null)}
        >
          <InviteVisitorForm
            visit={editVisit}
            closeModal={() => setEditVisit(null)}
          />
        </Modal>
      ) : null}
      {deleteVisit ? (
        <DeleteVisitModal
          setDeleteModal={setDeleteVisit}
          visitor={deleteVisit}
        />
      ) : null}
      {data ? (
        data.length === 0 ? (
          <p className="mx-auto my-10 text-center text-xl">
            No visits found.{' '}
            {hasChangedFromDefaults ? (
              <button className="text-primary" onClick={resetFilters}>
                Reset filters
              </button>
            ) : null}
          </p>
        ) : (
          <div className="overflow-x-auto mt-4 min-h-[300px] text-xs sm:text-base">
            <PaginatedTable
              data={data}
              columns={columns}
              hasMoreData={visits.hasNextPage}
              loadMore={() => {
                visits.fetchNextPage();
              }}
              loading={visits.isFetchingNextPage}
            />
          </div>
        )
      ) : null}
    </div>
  );
}
